<script lang="ts">
	//Services
	import { format } from '../../../../services/i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { getErrorOrInfoMessageForMinAndMax } from '../../../../helpers/utilities';
	//Stores
	import { devices_settings } from 'src/stores/device-runtime/status';
	import { getDeviceStatus, readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	//Design system components
	import { Button, Input } from '@Shelly/shelly-design-system';
	import { onMount } from 'svelte';

	export let device, channel;

	let id = real_id(device.id);
	let component;
	let settings;
	let value;

	let cache;

	let loading = false;

	const min = 1;
	const max = 50;

	const validate = () => {
		if (value >= max) {
			value = max;
		}
		if (value <= min) {
			value = min;
		}
	};
	const setDeltaThreshold = async () => {
		if (cache === value) return;
		loading = true;
		validate();
		const params = {
			id: channel,
			config: {
				report_thr: +value,
			},
		};

		const res: SettingRequest = await gen2Request(device, `input.SetConfig`, params);
		const response = onSettingsResponse(res, device);
		if (response) {
			settings[component].report_thr = value;
			devices_settings.update_devices_settings(id, settings);
			cache = value;
		} else {
			value = cache;
		}
		loading = false;
	};

	const getSettings = () => {
		component = `input:${channel}`;
		settings = readDeviceSettings(id);
		value = settings?.[component]?.report_thr;
		cache = value;
	};

	onMount(() => {
		getSettings();
	});
	$: (getSettings(), channel); //change settings based on channel

	$: deltaData = getErrorOrInfoMessageForMinAndMax(value, min, max);
</script>

<Input
	size="m"
	bind:value
	type={'number'}
	{min}
	{max}
	error={deltaData.error}
	info={deltaData.info}
	step={1}
	label={$format('delta_threshold')}
	on:change={validate}
	on:enter={setDeltaThreshold}
	id="input-swfiuvk"
	aria-labelledby="input-swfiuvk"
/>
<Button class="mt-s mb-s" {loading} size="m" width="full" on:click={setDeltaThreshold}>
	{$format('button_save')}
</Button>
